import { render, staticRenderFns } from "./Awardees.vue?vue&type=template&id=b4bd4104&"
import script from "./Awardees.vue?vue&type=script&lang=js&"
export * from "./Awardees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports